import { useButtonSounds } from '@/hooks/useButtonSounds';

interface ButtonSoundProviderProps {
  children: React.ReactNode;
}

// This component initializes button sounds within the provider tree
export function ButtonSoundProvider({ children }: ButtonSoundProviderProps) {
  useButtonSounds();
  return <>{children}</>;
}